import { render, staticRenderFns } from "./manualShipmentsBlock.vue?vue&type=template&id=680e768c"
import script from "./manualShipmentsBlock.vue?vue&type=script&lang=js"
export * from "./manualShipmentsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports